var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaviconDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favicon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "black",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "color",
    d: "M0.0644657 10.0972L7.41253 5.52635H11.2243C11.2536 5.52635 11.2826 5.53212 11.3096 5.54334C11.3366 5.55455 11.3612 5.57099 11.3819 5.5917C11.4025 5.61242 11.4189 5.63701 11.4301 5.66407C11.4412 5.69113 11.4469 5.72012 11.4468 5.74938C11.4499 5.78735 11.4416 5.82536 11.4231 5.85866C11.4046 5.89196 11.3767 5.91905 11.3429 5.93654L7.73382 8.1003C7.49935 8.24067 7.41721 8.52245 7.41721 8.73352L7.41357 10.0972H12V2.17205C12.0001 2.13404 11.9925 2.09641 11.9777 2.06142C11.9628 2.02643 11.941 1.99481 11.9136 1.96848C11.8862 1.94214 11.8538 1.92163 11.8182 1.90819C11.7827 1.89475 11.7448 1.88865 11.7068 1.89027H7.33039L0 6.44135V10.0972H0.0644657Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconDark);
export default __webpack_public_path__ + "static/media/favicon-dark.c686676974fdfbc0403b534153da3253.svg";
export { ForwardRef as ReactComponent };